import styled, { css } from "styled-components";

export const Box = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 24px 0 16px;
  border-bottom: 1px solid #dee2db;

  /* +ph ESTO ES TABLET
            border-bottom: none

    +ph
        flex-direction: column */
`;

export const Details = styled.div`
  flex-grow: 1;
  padding-right: 24px;
  /* +ph
        padding-right: 0
        margin-bottom: 10px */
`;
export const Category = styled.div`
  font-size: 19px;
  line-height: calc(24 / 16);
  font-weight: 500;
`;

export const SubTitle = styled.div`
  line-height: calc(20 / 12);
  font-size: 15px;
  color: #6b6b95;
  /* 
	+ph
        font-weight: 400
        font-size: 17px */
`;
export const ErrorText = styled.div`
  margin-top: 5px;
  color: #ff2467;
`;
